import '@assets/index.css';
import "devicon/devicon.min.css";
import React, {lazy, Suspense} from "react";
import {BrowserRouter} from "react-router-dom";
import ReactDOM from "react-dom/client";
import {OPENIZE_IS_COMING_SOON} from "@assets/config";

const ComingSoonRoutes = lazy(() =>
  import('@coming-soon/ComingSoonRoutes').then((mod) => ({
    default: (mod as any).ComingSoonRoutes ?? (mod as any).default,
  }))
);

const LandingRoutes = lazy(() =>
  import('@landing/LandingRoutes').then((mod) => ({
    default: (mod as any).LandingRoutes ?? (mod as any).default,
  }))
);

const App: React.FC = () => (
  <Suspense fallback={null}>
    {OPENIZE_IS_COMING_SOON ? <ComingSoonRoutes/> : <LandingRoutes/>}
  </Suspense>
);

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element not found');
const root = ReactDOM.createRoot(rootEl);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App/>
    </BrowserRouter>
  </React.StrictMode>
);